import React from 'react';
import { getFormikError, withFormikField } from 'utils/formik';
import { Radios, Spacer, Checkbox, Field } from '@ontruck/orc';

import { StyledExtraContainer, StyledFieldWrapper, ModifiedPriceExtraStyles } from './styled';

import { MODIFIED_PRICE_EXTRA, RETURN_EXTRA } from 'modules/shipper-order/Form/constants';
import { IS_TENANT } from 'tenant/config';
import { injectIntl } from 'react-intl';

export function getSource(quote) {
  if (quote?.is_manual || !quote?.is_contract) return '';

  return quote?.contract_type === 'informal' ? 'FPA_INFORMAL' : 'FPA_TENDER';
}

const ModifedPriceExtra = ({ currency, form, quote, isLast, className, intl }) => {
  const { values: formValues, setFieldValue } = form;
  const t = intl.messages.modules.shipper_order.form.extras.modified_price;
  const formExtras = formValues?.extra_prices;
  const formExtra = formExtras?.find((extra) => extra.concept === MODIFIED_PRICE_EXTRA);
  const hasReturnExtra = !!formExtras?.find((extra) => extra.concept === RETURN_EXTRA);

  const formExtrasNames = (formExtras || []).map((extra) => extra?.concept);
  const formExtraPosition = formExtrasNames.indexOf(MODIFIED_PRICE_EXTRA);
  const error = Object.keys(
    getFormikError({ field: { name: `extra_prices.${formExtraPosition}` }, form }) || {}
  ).length;

  const isChecked = !!formExtra;
  const extraSource = getSource(quote);

  const toggleExtra = (e, { value: activatingExtra }) => {
    if (activatingExtra) return createModifiedPriceExtra();

    return setFieldValue(
      'extra_prices',
      formExtras.filter((extra) => extra.concept !== MODIFIED_PRICE_EXTRA)
    );
  };

  const changeModifiedPriceSource =
    (e, { value }) =>
    () => {
      const formExtrasWithoutModifiedPrice = formExtras.filter(
        (extra) => extra.concept !== MODIFIED_PRICE_EXTRA
      );

      setFieldValue('extra_prices', [
        ...formExtrasWithoutModifiedPrice,
        { ...formExtra, source: value },
      ]);
    };

  const changeModifiedPriceAmount = (e, { value }) => {
    const formExtrasWithoutModifiedPrice = (formExtras || []).filter(
      (extra) => extra.concept !== MODIFIED_PRICE_EXTRA
    );

    setFieldValue('extra_prices', [
      ...(formExtrasWithoutModifiedPrice || []),
      { ...(formExtra || {}), amount: value },
    ]);
  };

  const createModifiedPriceExtra = () => {
    setFieldValue('extra_prices', [
      ...(formExtras || []),
      {
        concept: MODIFIED_PRICE_EXTRA,
        source: IS_TENANT ? 'FPA_INFORMAL' : extraSource,
        amount: '',
        include_in_base: false,
        reviewed_by_shipper: false,
        type: 'NUMERIC',
      },
    ]);
  };

  return (
    <div className={className}>
      <StyledExtraContainer isLast={isLast}>
        <div className="container">
          <div className="first-column">
            <Spacer>
              <Checkbox
                checked={isChecked}
                label={t.label}
                onChange={toggleExtra}
                dataE2E="modified-price_checkbox"
                disabled={hasReturnExtra}
              />
              <span className="sublabel">{isChecked ? t.sublabelEnabled : t.sublabelDisabled}</span>
              {IS_TENANT && isChecked && (
                <div className="inner-field-container tenant-field">
                  <Field
                    fullWidth
                    value={formExtra?.amount || ''}
                    label={t.base}
                    width="XS"
                    asideRightText={t.currencies[currency]}
                    onChange={changeModifiedPriceAmount}
                    invalid={!!error}
                  />
                </div>
              )}
            </Spacer>
          </div>

          <div className="inner-container">
            <StyledFieldWrapper visible={isChecked && !IS_TENANT} fullWidth>
              <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                <div className="inner-options-container">
                  <Radios
                    legend=""
                    size="M"
                    value={formExtra?.source}
                    onChange={changeModifiedPriceSource}
                    items={[
                      { value: 'SPOT', label: t.spot },
                      { value: 'FPA_TENDER', label: t.tender },
                      { value: 'FPA_INFORMAL', label: t.informal },
                    ]}
                  />
                </div>

                <div className="inner-field-container">
                  <Field
                    fullWidth
                    value={formExtra?.amount || ''}
                    label={t.base}
                    width="XS"
                    asideRightText={t.currencies[currency]}
                    onChange={changeModifiedPriceAmount}
                    invalid={!!error}
                  />
                </div>
              </div>
            </StyledFieldWrapper>
          </div>
        </div>
      </StyledExtraContainer>
    </div>
  );
};

export default withFormikField(ModifiedPriceExtraStyles(injectIntl(ModifedPriceExtra)));
